const DOMAIN_PATTERNS = {
  piaui: /^(dev|hml|)\.?laudos\.piauisaudedigital\.com\.br/,
  amazonas: /^(dev|hml|)\.?laudos\.saudeamdigital\.am\.gov\.br/,
  alagoas: /^(dev|hml|)\.?laudos\.saudeatevoce\.al\.gov\.br/,
  amapa: /^(dev|hml|)\.?laudos\.saudedagentetelemedicina\.ap\.gov\.br/
}

export function getAppHostname () {
  const override = import.meta.env.VITE_DEV_HOSTNAME
  if (import.meta.env.DEV && override) {
    return String(override).replace(/^https?:\/\//, '').split('/')[0]
  }
  return window.location.hostname
}

export function isPiauiHostname (hostname = getAppHostname()) {
  return DOMAIN_PATTERNS.piaui.test(hostname)
}

export function isAmazonasHostname (hostname = getAppHostname()) {
  return DOMAIN_PATTERNS.amazonas.test(hostname)
}

export function isAlagoasHostname (hostname = getAppHostname()) {
  return DOMAIN_PATTERNS.alagoas.test(hostname)
}

export function isAmapaHostname (hostname = getAppHostname()) {
  return DOMAIN_PATTERNS.amapa.test(hostname)
}

export function isPortalHostname (hostname = getAppHostname()) {
  return !isPiauiHostname(hostname) &&
    !isAmazonasHostname(hostname) &&
    !isAlagoasHostname(hostname) &&
    !isAmapaHostname(hostname)
}

export function getLoginLogoPath (hostname = getAppHostname()) {
  if (isPiauiHostname(hostname)) {
    return '../../assets/img/logo-piaui-saude-digital.png'
  }
  if (isAmazonasHostname(hostname)) {
    return '../../assets/img/logo-amazonas-saude-digital.png'
  }
  if (isAlagoasHostname(hostname)) {
    return '../../assets/img/logo-alagoas-saude.png'
  }
  if (isAmapaHostname(hostname)) {
    return '../../assets/img/logo-amapa-saude-da-gente-horizontal.png'
  }
  return '../../assets/img/logo-portal-telemedicina.png'
}

export function getHeaderLogoPath (hostname = getAppHostname()) {
  if (isPiauiHostname(hostname)) {
    return '../../assets/img/logo-piaui-saude-digital.png'
  }
  if (isAmazonasHostname(hostname)) {
    return '../../assets/img/logo-header-amazonas-saude-digital.png'
  }
  if (isAlagoasHostname(hostname)) {
    return '../../assets/img/logo-header-alagoas-saude.png'
  }
  if (isAmapaHostname(hostname)) {
    return '../../assets/img/logo-amapa-saude-da-gente-horizontal.png'
  }
  return '../../assets/img/logo-portal-telemedicina.png'
}
